import { Typography } from "@mui/material";

export default function Empty() {
	return <Typography variant='subtitle2'>{"-"}</Typography>;
}
